
export const CASTELLE_INVOICE_REPORT = "Castelle Invoice Report";
export const CASTELLE_CUSTOMER_NAME = "castelle";

export const EMAIL = {
  label: "Email",
  validation: {
    required: "Please enter an email",
    valid: "Please enter a valid email address.",
  },
};

export const PHONENUMBER = {
  label: "PhoneNumber",
  validation: {
    required: "Phone number is required",
    valid: "Please enter valid phone number.",
    consigneeValid: "Please enter valid phone number.",
  },
};

export const FIRST_NAME = {
  label: "First Name",
  validation: {
    required: "First name is required.",
    valid: "Please enter valid first name",
  },
};

export const LAST_NAME = {
  label: "Last Name",
  validation: {
    required: "Last name is required.",
    valid: "Please enter valid last name",
  },
};

export const ROLE = {
  label: "ROLE",
  validation: {
    required: "Role is required.",
  },
};

export const PASSWORD = {
  label: "Password",
  validation: {
    required: "Please enter password.",
    valid: "Incorrect password.",
    match: "Password and Confirm Password does not match.",
  },
};

export const CONFIRM_PASSWORD = {
  label: "Confirm Password",
  validation: {
    required: "Please enter confirm password.",
    match: "Password and Confirm Password does not match.",
  },
};

export const ADDRESS = {
  label: "Address",
  validation: {
    valid: "Please enter an address.",
  },
};

export const CITY = {
  label: "City",
  validation: {
    valid: "Please select a city.",
  },
};

export const STATE = {
  label: "State",
  validation: {
    valid: "Please select a state.",
  },
};

export const ZIP_CODE = {
  label: "Zip code",
  validation: {
    valid: "Please enter a valid zip code.",
    required: "Please enter a zip code.",
  },
};

export const CUSTOMERNAME = {
  label: "Customer name",
  validation: {
    required: "Please enter customer name.",
    valid: "Please enter valid customer name.",
  },
};

export const CONTACT_PERSON = {
  label: "Contact person",
  validation: {
    required: "Please enter contact name.",
  },
};

export const PHONE_EXT = {
  label: "Phone Ext",
  validation: {
    required: "Please enter phone ext.",
  },
};

export const AGENT_NAME = {
  label: "Agent Name",
  validation: {
    required: "Please enter agent name.",
  },
};

export const AGENT_TYPE = {
  label: "Agent Type",
  validation: {
    required: "Please select agent type.",
  },
};

export const HUB_NAME = {
  label: "Hub Name",
  validation: {
    required: "Please enter hub name.",
  },
};

export const ACTIVE_DATE = {
  label: "Active Date",
  validation: {
    required: "Please select active date.",
  },
};

export const DEACTIVATE_DATE = {
  label: "Deactivate Date",
  validation: {
    required: "Please select deactivate date.",
  },
};

export const ORDER_STATUS = {
  label: "Order Status",
  validation: {
    required: "Please select order status type.",
  },
};

export const STATUS_LOCATION = {
  label: "Status Location",
  validation: {
    required: "Please enter status location.",
  },
};

export const STATUS_TIME = {
  label: "Status Time",
  validation: {
    required: "Please select status time.",
  },
};

export const STATUS_DATE = {
  label: "Status Date",
  validation: {
    required: "Please select status date.",
  },
};

export const STATUS_NOTE = {
  label: "Status Note",
  validation: {
    required: "Please enter status note.",
  },
};

export const API_URL = {
  label: "Api Url",
  validation: {
    required: "Please enter xcelerator api url.",
  },
};

export const API_ACCOUNT_NO = {
  label: "Api Account",
  validation: {
    required: "Please enter xcelerator account number.",
  },
};

export const API_LOGIN = {
  label: "Api Login",
  validation: {
    required: "Please enter xcelerator login.",
  },
};

export const API_PASSWORD = {
  label: "Api Password",
  validation: {
    required: "Please enter xcelerator password.",
  },
};

export const START_DATE = {
  label: "Start Date",
  validation: {
    required: "Please select start date.",
  },
};

export const X_SERVICE_CODE = {
  label: "X Service Code",
  validation: {
    required: "Please enter xcelerator service code.",
  },
};

export const X_SERVICE_ID = {
  label: "X Service Id",
  validation: {
    required: "Please enter xcelerator service id.",
  },
};

export const X_SERVICE_DURATION = {
  label: "X Service Duration",
  validation: {
    required: "Please enter xcelerator service duration.",
  },
};

export const X_SERVICE_DETAILS = {
  label: "X Service DETAILS",
  validation: {
    required: "Please enter xcelerator service details.",
  },
};

export const CUSTOMER_TYPE = [
  { name: "Direct Customer", id: "first" },
  { name: "Parent Customer", id: "second" },
  { name: "Sub Customer", id: "third" },
  { name: "Omni Move", id: "zero" },
];
export const CUSTOMER_TYPE_SECOND = [
  { name: "Parent Customer", id: "second" },
  { name: "Sub Customer", id: "third" },
];
export const ROLES = [
  { name: "Employee", id: "employee" },
  { name: "Manager", id: "manager" },
];
export const PAYMENT_STATUS = [
  { name: "Paid", id: "paid" },
  { name: "Unpaid", id: "unpaid" },
];
export const PACKAGE_TYPE = [
  { id: "BAG", name: "BAG" },
  { id: "BALE", name: "BALE" },
  { id: "BOX", name: "BOX" },
  { id: "BUNDLE", name: "BUNDLE" },
  { id: "CARTON", name: "CARTON" },
  { id: "CASE", name: "CASE" },
  { id: "CRATE", name: "CRATE" },
  { id: "DRUM", name: "DRUM" },
  { id: "PAIL", name: "PAIL" },
  { id: "PLT", name: "PLT" },
  { id: "PIECES", name: "PIECES" },
  { id: "REEL", name: "REEL" },
  { id: "ROLL", name: "ROLL" },
  { id: "SKID", name: "SKID" },
  { id: "TANK", name: "TANK" },
  { id: "TRAILER", name: "TRAILER" },
];

export const EXPEDIET_PACKAGE_TYPE = [
  { id: "A-FRAME", name: "A-FRAME" },
  { id: "ACCESSORIES", name: "ACCESSORIES" },
  { id: "ATTACHMENTS", name: "ATTACHMENTS" },
  { id: "BAGS", name: "BAGS" },
  { id: "BALES", name: "BALES" },
  { id: "BARREL", name: "BARREL" },
  { id: "BASKET", name: "BASKET" },
  { id: "BATTERIES", name: "BATTERIES" },
  { id: "BINS", name: "BINS" },
  { id: "BOX", name: "BOX" },
  { id: "BREAK BULK", name: "BREAK BULK" },
  { id: "BUCKETS", name: "BUCKETS" },
  { id: "BULKHEAD", name: "BULKHEAD" },
  { id: "BUNDLE", name: "BUNDLE" },
  { id: "CANS", name: "CANS" },
  { id: "CARBOYS", name: "CARBOYS" },
  { id: "CART", name: "CART" },
  { id: "CARTON", name: "CARTON" },
  { id: "CASE", name: "CASE" },
  { id: "CHEST", name: "CHEST" },
  { id: "COILS", name: "COILS" },
  { id: "CONTAINER", name: "CONTAINER" },
  { id: "CRATE", name: "CRATE" },
  { id: "CYLINDER", name: "CYLINDER" },
  { id: "DRUM", name: "DRUM" },
  { id: "EACH", name: "EACH" },
  { id: "ENVELOPES", name: "ENVELOPES" },
  { id: "FEET", name: "FEET" },
  { id: "FIRKINS", name: "FIRKINS" },
  { id: "GALLONS", name: "GALLONS" },
  { id: "GAYLORDS", name: "GAYLORDS" },
  { id: "HALFPALLETS", name: "HALFPALLETS" },
  { id: "HOPPER", name: "HOPPER" },
  { id: "JERRICANS", name: "JERRICANS" },
  { id: "KEGS", name: "KEGS" },
  { id: "LIFT VAN", name: "LIFT VAN" },
  { id: "LOOSE", name: "LOOSE" },
  { id: "OCTABIN", name: "OCTABIN" },
  { id: "PACKAGE", name: "PACKAGE" },
  { id: "PAILS", name: "PAILS" },
  { id: "PALLET", name: "PALLET" },
  { id: "PIECE", name: "PIECE" },
  { id: "PLASTIC JERRICANS", name: "PLASTIC JERRICANS" },
  { id: "RACKS", name: "RACKS" },
  { id: "REEL", name: "REEL" },
  { id: "ROLL", name: "ROLL" },
  { id: "SKID", name: "SKID" },
  { id: "SLIPSHEETS", name: "SLIPSHEETS" },
  { id: "STACKS", name: "STACKS" },
  { id: "SUPERSACK", name: "SUPERSACK" },
  { id: "TOTES", name: "TOTES" },
  { id: "TRAYS", name: "TRAYS" },
  { id: "TRUCKLOAD", name: "TRUCKLOAD" },
  { id: "TUBE", name: "TUBE" },
  { id: "TUBS", name: "TUBS" },
  { id: "U-BOX", name: "U-BOX" },
  { id: "UNIT", name: "UNIT" },
  { id: "UNPACKAGED", name: "UNPACKAGED" },
  { id: "VEHICLE", name: "VEHICLE" },
  { id: "WHEELS", name: "WHEELS" },
];

export const FREIGHT_CLASS = [
  { id: "50", name: "50" },
  { id: "55", name: "55" },
  { id: "60", name: "60" },
  { id: "65", name: "65" },
  { id: "70", name: "70" },
  { id: "77.5", name: "77.5" },
  { id: "85", name: "85" },
  { id: "92.5", name: "92.5" },
  { id: "100", name: "100" },
  { id: "110", name: "110" },
  { id: "125", name: "125" },
  { id: "150", name: "150" },
  { id: "175", name: "175" },
  { id: "200", name: "200" },
  { id: "250", name: "250" },
  { id: "300", name: "300" },
  { id: "400", name: "400" },
  { id: "500", name: "500" },
];

export const DATASET = [
  { x: new Date(2024, 11, 1), y: 2 },
  { x: new Date(2024, 11, 5), y: 5.5 },
  { x: new Date(2024, 11, 10), y: 2 },
  { x: new Date(2024, 11, 15), y: 8.5 },
  { x: new Date(2024, 11, 20), y: 1.5 },
  { x: new Date(2024, 11, 25), y: 5 },
];

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];



export const BOOKING_ORDER_STATUS = [
  "Back Order",
  "Booked",
  "Cancelled",
  "Claim",
  "Pending",
  "Quoted",
];
export const IN_TRANSIT_ORDER_STATUS = [
  "1st Call Made Left Voicemail",
  "Accident",
  "Agent Update Request",
  "Appointment Scheduled",
  "Breakdown",
  "Customer Contacted",
  "Delay not Weather",
  "Delay, Weather",
  "Dispatched",
  "Estimated Delivery Date",
  "Expected Receive Date to Agent",
  "Holiday",
  "In Transit",
  "In Transit from DC to Final Mile Hub",
  "Incorrect Address",
  "Left Voicemail",
  "Loaded on Truck",
  "Mis-sort",
  "Missed Pick-up",
  "Need contact info",
  "Not Picked Up",
  "On Hold",
  "Picked up",
  "Pickup Scheduled",
  "Ready to Route",
  "Received",
  "Received at Distribution Center",
  "Received Damaged",
  "Reconsignment",
  "Request of LTL PRO",
  "Requested Update from Customer",
  "Rescheduled",
  "Return ready",
  "Weather",
  "Open",
  "Undelivered",
];
export const OUT_DELIVERY_ORDER_STATUS = [
  "Delivery Attempted",
  "Out for delivery",
  "Refused/Attempted",
];
export const DELIVERED_ORDER_STATUS = [
  "Delivered",
  "Delivered Awaiting POD",
  "Delivered Awaiting Pictures",
  "Delivered Awaiting POD And Pictures",
  "Delivered Damaged",
  "Delivered Over",
  "Delivered Short",
  "Finalized",
  "Invoiced",
  "POD Requested from Agent",
  "Unfinalized",
];
export const DELIVERED_AWAITING_STATUSES = [
  "Delivered Awaiting POD And Pictures",
  "Delivered Awaiting POD",
  "Delivered Awaiting Pictures",
];

export const CANCELLED_ORDER_STATUS = ["Cancelled"];

export const CUSTOMER_INACTIVE_ACTIVE_HUB = [
  "Active hubs and LTL agents saved successfully!",
  "An unknown error occurred during save.",
];

const NON_PROD_ENVS = ["local", "development", "staging", "uat"];
const isNonProd = NON_PROD_ENVS.includes(process.env.REACT_APP_ENV || "");
const S3_BUCKET_NAME = isNonProd
  ? "omni-move-import-template-development"
  : "omni-move-import-template";
export const S3_TEMPLATE_BASE_URL = `https://${S3_BUCKET_NAME}.s3.us-east-1.amazonaws.com`;

export const DOWNLOAD_SERVICE_TEMPLATE_URL =
  `${S3_TEMPLATE_BASE_URL}/ServiceZIP.xlsx`;
export const DOWNLOAD_AGENT_MILE_ZONE_URL =
  `${S3_TEMPLATE_BASE_URL}/AgentsMileZone.xlsx`;
export const DOWNLOAD_AGENT_RATE_ZONE_URL =
  `${S3_TEMPLATE_BASE_URL}/AgentRateWithWeightZone_Template.xlsx`;
export const DOWNLOAD_LTL_AGENT_RATE_URL =
  `${S3_TEMPLATE_BASE_URL}/internalltlagentrateimport.xlsx`;
export const DOWNLOAD_AGENT_LIST_URL =
  `${S3_TEMPLATE_BASE_URL}/AgentsTemplate.xlsx`;
export const DOWNLOAD_AGENT_HUB_LIST_URL =
  `${S3_TEMPLATE_BASE_URL}/AgentHubTemplate.xlsx`;
export const DOWNLOAD_FSC_AGENT_LIST_URL =
  `${S3_TEMPLATE_BASE_URL}/fscagent.xlsx`;
export const DOWNLOAD_FSC_AGENT_INTERNAL_LTL_URL =
  `${S3_TEMPLATE_BASE_URL}/fscagentinternal.xlsx`;
export const DOWNLOAD_AGENT_WEIGHT_ZONE_URL =
  `${S3_TEMPLATE_BASE_URL}/AgentsWeightZone.xlsx`;
export const DOWNLOAD_AGENT_HUB_ACTIVE_CUSTOMER_URL =
  `${S3_TEMPLATE_BASE_URL}/HubActiveCustomer.xlsx`;
export const DOWNLOAD_CUSTOMER_LIST_URL =
  `${S3_TEMPLATE_BASE_URL}/customerimport.xlsx`;
export const DOWNLOAD_CUSTOMER_RATE_LIST_URL =
  `${S3_TEMPLATE_BASE_URL}/CustomerRateImport.xlsx`;
export const DOWNLOAD_FSC_CUSTOMER_URL =
  `${S3_TEMPLATE_BASE_URL}/customerfsclist.xlsx`;
export const DOWNLOAD_AGENT_ADDITIONAL_CHARGES =
  `${S3_TEMPLATE_BASE_URL}/agentadditionalcharges.xls`;
export const DOWNLOAD_FINAL_MILE_AGENT_ADDITIONAL_CHARGES =
  `${S3_TEMPLATE_BASE_URL}/finalmileagentadditionalcharges.xlsx`;
export const DOWNLOAD_LTL_AGENT_ADDITIONAL_CHARGES =
  `${S3_TEMPLATE_BASE_URL}/ltlagentadditionalcharges.xlsx`;
export const DOWNLOAD_CUSTOMER_ADDITIONAL_CHARGES =
  `${S3_TEMPLATE_BASE_URL}/customeradditionalcharges.xlsx`;
export const DOWNLOAD_CUSTOMER_TECH_FEE_URL =
  `${S3_TEMPLATE_BASE_URL}/customertechnologyfee.xlsx`;
// MASTER SEARCH TOOLTIP TEST
export const MASTER_SEARCH_TOOL_TIP_TEXT =
  "Search by Order Number, DC Order Number, References, BOL#, PRO#, Consignee Name, Consignee Address, Consignee Zip Code, Phone # and Invoice #";
// Shorter form for the search inputs themselves, where the full tooltip does not fit.
export const MASTER_SEARCH_PLACEHOLDER =
  "Search by Order Number, DC Order Number, Reference Number and Customer Name";
export const BULK_QUOTE_TEMPLATEURL =
  `${S3_TEMPLATE_BASE_URL}/`;
export const DOWNLOAD_SCAC_LIST_URL =
  `${S3_TEMPLATE_BASE_URL}/scac.xlsx`;
export const DOWNLOAD_LTL_PICKUP_ZIPCODE_URL =
  `${S3_TEMPLATE_BASE_URL}/internalpickupzipcode.xlsx`;
export const DOWNLOAD_LTL_DROP_ZIPCODE_URL =
  `${S3_TEMPLATE_BASE_URL}/internaldropzipcode.xlsx`;
export const DOWNLOAD_MASTER_ZIP_CODE_TEMPLATE_URL =
  `${S3_TEMPLATE_BASE_URL}/masterzipcodetemplate.xlsx`;

/**
 * Agent scoped import templates.
 *
 * Unlike the static `DOWNLOAD_*_URL` links above, these templates are generated
 * per agent by `DOWNLOAD_IMPORT_TEMPLATE` (the API pre-fills the agent's data and
 * responds with a short lived pre-signed URL).
 *
 * To support a new template: add the API's `templateType` value here, add its
 * label below, and flag it in `HUB_SCOPED_TEMPLATE_TYPES` if it needs a hub id.
 */
export const IMPORT_TEMPLATE_TYPE = {
  AGENT_RATE: "agentRate",
  AGENT_HUB: "agentHub",
  FSC_AGENT: "fscAgent",
  FINAL_MILE_AGENT_ADDITIONAL: "finalMileAgentAdditional",
  SERVICE_ZIP: "ServiceZip",
  // Internal LTL agents get their own sheet layout for the same screens.
  INTERNAL_LTL_AGENT_RATE: "internalltlagentrate",
  FSC_AGENT_INTERNAL: "fscAgentInternal",
  LTL_AGENT_ADDITIONAL_CHARGES: "ltlAgentAdditional",
  INTERNAL_PICKUP_ZIP: "internalPickupZip",
  INTERNAL_DROP_ZIP: "internalDropZip",
} as const;

export type ImportTemplateType =
  (typeof IMPORT_TEMPLATE_TYPE)[keyof typeof IMPORT_TEMPLATE_TYPE];

/**
 * Templates scoped to a single agent hub. `hubId` is required for these types
 * and is never sent for any other type.
 */
export const HUB_SCOPED_TEMPLATE_TYPES: ImportTemplateType[] = [
  IMPORT_TEMPLATE_TYPE.SERVICE_ZIP,
];

/** Default download button labels — call sites may override with their own. */
export const IMPORT_TEMPLATE_LABELS: Record<ImportTemplateType, string> = {
  [IMPORT_TEMPLATE_TYPE.AGENT_RATE]: "Download Agent Rate Template",
  [IMPORT_TEMPLATE_TYPE.AGENT_HUB]: "Download Agent Hub Template",
  [IMPORT_TEMPLATE_TYPE.FSC_AGENT]: "Download FSC Agent Template",
  [IMPORT_TEMPLATE_TYPE.FINAL_MILE_AGENT_ADDITIONAL]:
    "Download Additional Charges Template",
  [IMPORT_TEMPLATE_TYPE.SERVICE_ZIP]: "Download Zipcode Template",
  // Internal LTL variants keep the same wording as their counterparts — the
  // screen shows one button either way.
  [IMPORT_TEMPLATE_TYPE.INTERNAL_LTL_AGENT_RATE]:
    "Download Agent Rate Template",
  [IMPORT_TEMPLATE_TYPE.FSC_AGENT_INTERNAL]: "Download FSC Agent Template",
  [IMPORT_TEMPLATE_TYPE.LTL_AGENT_ADDITIONAL_CHARGES]:
    "Download Additional Charges Template",
  [IMPORT_TEMPLATE_TYPE.INTERNAL_PICKUP_ZIP]:
    "Download Pickup Zipcode Template",
  [IMPORT_TEMPLATE_TYPE.INTERNAL_DROP_ZIP]: "Download Drop Zipcode Template",
};


export const ORDER_TYPE_CONSTANTS = {
  BANYAN: "banyan",
  PROVIDENCE: "providence",
};

export const LTL_ORDER_TYPES = ["ltl", "ltl + final mile"];

// Final Mile Service Type (Service.logisticsType). Only applies when Order Type = Final Mile.
export const LOGISTICS_TYPE = {
  DELIVERY: "delivery",
  PICKUP: "pickup",
};
// Module-level so the reference stays stable — SingleDropdown syncs `staticData` on change.
export const FINAL_MILE_SERVICE_TYPE_OPTIONS = [
  { id: LOGISTICS_TYPE.DELIVERY, name: "Delivery" },
  { id: LOGISTICS_TYPE.PICKUP, name: "Pickup" },
];

// Additional charges that cannot be removed from an order (delete icon hidden).
export const NON_DELETABLE_CHARGES = ["Technology Fee", "Wait Time"];

// Pass-through additional charges billed to the customer at cost — no customer
// markup is applied, so the charges breakdown shows them without markup.
export const MARKUP_EXEMPT_CHARGES = [
  "ForwardAir Transfer",
  "Technology Fee",
  "Linehaul Fee",
];

// Charges that cannot be removed specifically from the Customer rate table. On flat-rate FM the
// FM-linked charges are now deletable from the customer side independently of the agent side, so
// this list is empty (only the both-sides NON_DELETABLE_CHARGES still hide the delete icon).
export const NON_DELETABLE_CUSTOMER_CHARGES: string[] = [];

// Groups of additional charges that cannot be applied at the same time.
export const MUTUALLY_EXCLUSIVE_CHARGES = [
  ["Order Swap & Exchange", "Remove & Disposal"],
];

export const omniMoveRoles = [
  "superadmin",
  "admin",
  "manager",
  "employee",
  "agent",
  "customersuperadmin",
];

// Roles allowed to set a password for and activate an account that has not
// completed onboarding: Super Admin, Admin and Manager. Super Admin is
// "superadmin" on OmniMove and "customersuperadmin" on a customer tenant — the
// tenancy itself is scoped by the caller (isUserOfOmniMove / customerLevel).
export const ACCOUNT_ACTIVATION_ROLES = [
  "superadmin",
  "customersuperadmin",
  "admin",
  "manager",
];

// Decision D1 (Tech Fee): the tab and its add / edit routes are for a Direct
// Customer's Super Admin, Admin, Manager and Employee. The tenancy (first level,
// not OmniMove) is checked by the caller, as with ACCOUNT_ACTIVATION_ROLES.
export const TECH_FEE_ROLES = [
  "customersuperadmin",
  "admin",
  "manager",
  "employee",
];

export const PAGE_SIZE_OPTIONS = [15, 25, 50, 75, 100];
export const DEFAULT_PAGE_SIZE = 50;

// Default pickup/drop dock hours pre-filled on the order and quote forms.
export const DEFAULT_DOCK_OPEN_TIME = "08:00 AM";
export const DEFAULT_DOCK_CLOSE_TIME = "05:00 PM";
// --- Mandatory-field validation on the order / quote screens -----------------

/** Pseudo field keys for the mandatory values that live in dropdowns rather than `fields`. */
export const DROPDOWN_FIELD_KEYS = {
  customer: "customerName",
  orderType: "orderType",
  service: "serviceLevel",
  agent: "agentName",
  agentHub: "agentHub",
} as const;

/** `data-field` anchor the validation scrolls to when a handling unit is incomplete. */
export const HANDLING_UNITS_FIELD_KEY = "handlingUnits";

/** Item Dimension is one labelled column backed by these three inputs. */
export const ITEM_DIMENSION_KEYS = ["length", "width", "height"];

/**
 * Message-facing field names. The visible <label> text is section-scoped and ambiguous
 * ("Address", "Zip Code" and "Contact Name" each appear in both the origin and the
 * destination blocks), so these are qualified to keep the message actionable.
 */
export const ORDER_FIELD_LABELS: Record<string, string> = {
  // Dropdowns
  [DROPDOWN_FIELD_KEYS.customer]: "Customer Name",
  [DROPDOWN_FIELD_KEYS.orderType]: "Order Type",
  [DROPDOWN_FIELD_KEYS.service]: "Service Level",
  [DROPDOWN_FIELD_KEYS.agent]: "Agent Name",
  [DROPDOWN_FIELD_KEYS.agentHub]: "Agent Hub",

  // Order level
  orderReference: "Order Reference 1",
  serviceCost: "Service Cost",

  // Destination
  destinationAddress: "Destination Address",
  destinationZipcode: "Destination Zip Code",
  destinationBusinessLocation: "Destination Business Location",
  destinationConsigneeName: "Destination Consignee Name",
  destinationConsigneePhoneNumber: "Destination Consignee Phone Number",

  // Origin
  OriginAddress: "Origin Address",
  OriginZipcode: "Origin Zip Code",
  OriginBusinessLocation: "Origin Business Location",
  OriginConsigneeName: "Origin Contact Name",
  OriginConsigneePhoneNumber: "Origin Contact Phone Number",

  // Mid stop
  MidStopAddress: "Mid Stop Address",
  MidStopZipcode: "Mid Stop Zip Code",

  // Docks
  PickUpDockDate: "Pickup Date",
  PickUpDockTime: "Pickup Time",
  PickUpDockOpenTime: "Pickup Dock Open Time",
  PickUpDOckCloseTime: "Pickup Dock Close Time",
  DropDockOpenTime: "Drop Dock Open Time",
  DropDOckCloseTime: "Drop Dock Close Time",

  // Expedited windows
  PickupTargetDateFrom: "Pickup Target Date From",
  PickupTargetDateTo: "Pickup Target Date To",
  PickupTargetTimeFrom: "Pickup Target Time From",
  PickupTargetTimeTo: "Pickup Target Time To",
  PickupDeliveryDateFrom: "Pickup Delivery Date From",
  PickupDeliveryDateTo: "Pickup Delivery Date To",
  PickupDeliveryTimeFrom: "Pickup Delivery Time From",
  PickupDeliveryTimeTo: "Pickup Delivery Time To",
};

/** Handling-unit column names as shown in the compact grid (`tableConfig` headers). */
export const ITEM_FIELD_LABELS: Record<string, string> = {
  description: "Description",
  handlingUnit: "Handling Unit",
  quantity: "Quantity",
  weight: "Weight (lbs)",
  itemClass: "Item Class",
  packageType: "Package Type",
  nmfc: "NMFC#",
  length: "Length",
  width: "Width",
  height: "Height",
};

/**
 * Overrides for the handling-unit card layout, which labels several of the same values
 * differently from the compact grid. Anything absent falls back to ITEM_FIELD_LABELS.
 */
export const ITEM_CARD_FIELD_LABELS: Record<string, string> = {
  handlingUnit: "Handling Unit Amt",
  packageType: "Handling Unit Type",
  quantity: "Total Items/Pieces",
  weight: "Total Weight",
  itemDimension: "Item Dimension",
};

/** Package sub-row labels, as shown inside a handling-unit's package card. */
export const PACKAGE_FIELD_LABELS: Record<string, string> = {
  description: "Item Description",
  quantity: "Item/Piece Count",
  weight: "Item Weight",
};

/** Elements the validation may move focus to when a mandatory field is blank. */
export const FOCUSABLE_FIELD_SELECTOR =
  'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Marks the focus the mandatory-field validation moves programmatically. The dropdowns
 * open themselves when their caption is focused, which would cover the error message the
 * validation just wrote; they check for this attribute and stay closed instead.
 */
export const VALIDATION_FOCUS_ATTR = "data-validation-focus";
